import { InterfaceCourseHomeItem } from '@/apis/courseHome';
import { Dialog } from 'vant';
import VueRouter from 'vue-router';
import router from '@/router';
import { InterfaceLiveRecordItem } from '@/apis/onlineLive';
import { CoursePathItem, CourseHomeDataMap, InterfaceCourseHomeData } from './dictionary';
import i18n  from '@/lang/index';
// 跳转7个详情、编辑、创建页
// params
// type: 类型
// courseId： 课程id，
// courseRole：课程角色
// id：当前数据的id ，
// edit：默认为跳转详情页，传入  'edit'跳转编辑页面
export function typeRedirect(
  type: keyof InterfaceCourseHomeData,
  { courseId, courseRole, dataInfo,resourceId }: { courseId: string; courseRole: string; dataInfo?: InterfaceCourseHomeItem | { id: string; realType: number };resourceId?:string },
  handleType: string = '',
  inSource: string = ''
): void {
  // @ts-ignore
  if (type === 2 && dataInfo && dataInfo.realType === 8) {
    type = 8;
  }
  let pathDate: string | CoursePathItem | undefined;
  let path: string = '';
  if (handleType === 'edit') {
    pathDate = CourseHomeDataMap[type].editPath;
  } else if (handleType === 'create') {
    if (inSource === 'source') {//章节tab下发布的
      pathDate = `${CourseHomeDataMap[type].createPath}&chapterSource=1`;
    }else{
      pathDate = `${CourseHomeDataMap[type].createPath}&chapterSource=0`;
    }
  } else if (handleType === 'publish') {
    pathDate = CourseHomeDataMap[type].publishPath;
  } else {
    // 详情
    pathDate = CourseHomeDataMap[type].path;
  }
  // 若path为对象，则需要区分权限分别跳转
  if (typeof pathDate === 'object') {
    path = courseRole === '1' ? pathDate.teacher : pathDate.student;
  } else if (typeof pathDate === 'string') {
    path = pathDate;
  }
  if (!path) {
    throw Error('未配置跳转地址');
  }
  let query:any={
    id: dataInfo && dataInfo.id,
    courseId,
    courseRole
  }
  if (handleType === 'virtual' && resourceId) {
    query.showType = 'virtual'
    query.resourceId = resourceId
  }
  // @ts-ignore
  this.$router.push({
    path,
    query
  });
}

export function geMobiletCurrentURL(){
  let newUrl = "";
  let ua = window.navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    newUrl = window.location.href.split("#")[0];
  } else if (/android/.test(ua)) {
    newUrl = window.location.href.split('#')[0];
  }
  return newUrl;
}

export const isWechat = ((): boolean => {
  const ua = window.navigator.userAgent.toLowerCase();
  // @ts-ignore
  return !!(ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger');
})();
export const isIos = ((): boolean => {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('iphone') > -1 || ua.indexOf('ios') > -1;
})();
export const isAndroid = ((): boolean => {
  const ua = window.navigator.userAgent.toLowerCase();
  // @ts-ignore
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
})();

// 中控之外websocket接收消息时，操作
export function activeHudong(list: InterfaceLiveRecordItem[]) {
  // 添加课堂记录 1抢答2话题3互动4提问5课件6资料9智慧黑板板书 10黑板板书 11截图
  const doingqueue = () => {
    const res = list.shift();
    if (res && res.type === '1' && res.data.join === false) {
      Dialog.confirm({
        title: '老师已开启抢答',
        message: '是否前往课堂内进行抢答',
        confirmButtonText: '前往',
        cancelButtonText: i18n.t('Common.取消') as string
      })
        .then(() => {
          router.push({
            path: '/onlinelive',
            query: { courseId: sessionStorage.getItem('courseId') }
          });
        })
        .catch(() => {
          doingqueue;
        });
    } else if (res && res.type === '3' && res.data.join === false) {
      if (typeof res.data.id === 'string') {
        Dialog.confirm({
          title: '老师发起了互动答题',
          message: '是否参与答题',
          confirmButtonText: '加入',
          cancelButtonText: i18n.t('Common.取消') as string
        })
          .then(() => {
            router.push({
              path: '/InteractiveAnswers/answer',
              query: { stepid: res.data.id, state: '1', prestudy: '0', from: 'online' }
            });
          })
          .catch(() => {
            doingqueue;
          });
      } else if (typeof res.data.id === 'object') {
        // 若是一个数组，则多个互动答题
        Dialog.confirm({ message: '您有多个未参与的互动答题，请在上课页面的“课堂记录”中参与' })
          .then(() => {
            router.push({
              path: '/onlinelive',
              query: { courseId: sessionStorage.getItem('courseId') }
            });
          })
          .catch(() => {
            doingqueue;
          });
      }
    }
  };

  doingqueue();
}

//时间格式
export function ktpTransformTime(num: any) {
  let t=Number(num)
  if ( t === 0) {
    return '00:00:00'
  }else{
    let s: any = Math.floor(t / 1) % 60
    t = Math.floor(t / 60)
    let i: any = t % 60
    t = Math.floor(t / 60)
    let h: any = t % 24
    s = s.toString().length === 1 ? `0${s}` : s
    i = i.toString().length === 1 ? `0${i}` : i
    h = h.toString().length === 1 ? `0${h}` : h
    return h + ':' + i + ':' + s
  }
};

export const objCookie = {
  /**
   * 写入cookie
   * @param {string} name  [cookie name]
   * @param {any} value [cookie value]
   * @param {string} days
   */
  setCookie(name: string, value: any, days: number) {
    const d = new Date()
    d.setTime(d.getTime() + Math.floor(24 * 60 * 60 * 1000 * days))

    window.document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()}`
  },

  /**
   * 获得cookie
   * @param  {string} name
   */
  getCookie(name: string) {
    const v = window.document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)

    return v ? v[2] : null
  },

  /**
   * 删除cookie
   * @param  {string} name
   */
  deleteCookie(name: string) {
    this.setCookie(name, '', -1)
  }
}
